import loginMockupData from './mock/login.json'
import request from '@/utils/request'
import { isUseAPI } from '@/utils/check'
import { getToken, setToken } from '@/utils/token'

export function loginByPassword(userId, password) {
  // local 개발 환경이 아닐 경우, 무조건 서버를 조회해야 함
  if (isUseAPI()) {
    // 차후 변경될 Restful 형식에 따라 수정해야 함
    return request({
      url: '/login',
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      // Json에서 Key와 Value 같다면, ecma6 부터는 아래와 같이 쓸 수 있습니다.
      data: {
        password,
        user_id: userId
      },
      // post일 경우 data 항목에 json 형식으로 입력하면 payload 값에 입력 되어 들어갑니다.
      // data: {
      //   password: password
      // },
      // 에러 메시지를 출력하는 옵션 - useErrorMessage, false로 정의하면 에러가 나와도 출력되지 않는다. default는 true
      meta: {
        useErrorMessage: false,
        useTokenUpdate: true,
        apiVersion: 'v1.0'
      }
    })
  }

  // restful api를 사용하지 않을 경우
  // login.json에 등록된 계정만 가져온다.
  return new Promise(function(resolve, reject) {
    let res = loginMockupData[userId]
    if (res) {
      resolve(res)
      // mockup에서는 토큰값이 userId로 사용한다.
      setToken(userId)
    } else {
      var error = { code: '401' }
      reject(error)
    }
  })
}

export function getUserInfoBySessionPost() {
  if (isUseAPI()) {
    // 차후 변경될 Restful 형식에 따라 수정해야 함
    return request({
      url: '/login/user',
      method: 'post',
      meta: {
        apiVersion: 'v1.0'
      }
    })
  }

  // restful api를 사용하지 않을 경우
  // login.json에 등록된 계정만 가져온다.
  return new Promise(function(resolve, reject) {
    // local에서는 token 값에 userId를 넣는다.
    let res = loginMockupData

    // 기존 토큰 값 있는 여부 확인
    if (res && getToken()) {
      resolve(res)
    } else {
      var error = { code: '401' }
      reject(error)
    }
  })
}

export function getPassCert(userId) {
  if (isUseAPI()) {
    // 차후 변경될 Restful 형식에 따라 수정해야 함
    return request({
      url: `/hiway/login/auth/phone?user_id=${userId}`,
      meta: {
        useErrorMessage: false,
        apiVersion: '2.1.0',
        useTokenUpdate: true,
        useAuth: false
      },
      method: 'get'
    })
  }
}
export function certificate(certificateNumber) {
  if (isUseAPI()) {
    // 차후 변경될 Restful 형식에 따라 수정해야 함
    return request({
      url: `/hiway/login/auth/confirm?authnum=${certificateNumber}`,
      meta: {
        useErrorMessage: false,
        apiVersion: '2.1.0',
        useAuth: false
      },
      method: 'get'
    })
  }
}
export function loginbyId(userId) {
  if (isUseAPI()) {
    // 차후 변경될 Restful 형식에 따라 수정해야 함
    return request({
      url: '/hiway/login/token',
      meta: {
        useErrorMessage: false,
        useTokenUpdate: true,
        apiVersion: '2.0.0'
      },
      method: 'post',
      data: {
        user_id: userId
      }
    })
  }
}
// login 이후 세션 정보를 통하여 유저 정보를 가져오기
export function getUserInfoBySession() {
  if (isUseAPI()) {
    // 차후 변경될 Restful 형식에 따라 수정해야 함
    return request({
      url: '/hiway/login/user',
      meta: { apiVersion: '2.0.0' },
      method: 'get'
    })
  }

  // restful api를 사용하지 않을 경우
  // login.json에 등록된 계정만 가져온다.
  return new Promise(function(resolve, reject) {
    // local에서는 token 값에 userId를 넣는다.
    let userId = getToken()
    let res = loginMockupData[userId]

    // 기존 토큰 값 있는 여부 확인
    if (res) {
      resolve(res)
    } else {
      var error = { code: '401' }
      reject(error)
    }
  })
}

export function logout() {
  if (isUseAPI()) {
    // 차후 변경될 Restful 형식에 따라 수정해야 함
    return request({
      url: '/login/sessionout',
      method: 'get'
    })
  }

  // restful api를 사용하지 않을 경우
  return new Promise(function(resolve, reject) {
    resolve()
  })
}

export function loginSso() {
  if (isUseAPI()) {
    // 차후 변경될 Restful 형식에 따라 수정해야 함
    return request({
      url: '/hiway/login/sso',
      meta: {
        apiVersion: '2.0.0',
        useTokenUpdate: true,
        useResponseAll: true,
        useErrorMessage: false
      },
      method: 'post'
    })
  }

  return new Promise(function(resolve, reject) {
    resolve()
  })
}
export function touchOneLoginSso(userId) {
  if (isUseAPI()) {
    // 차후 변경될 Restful 형식에 따라 수정해야 함
    return request({
      url: '/hiway/login/token',
      meta: {
        apiVersion: '2.0.0',
        useTokenUpdate: true,
        useResponseAll: true,
        useErrorMessage: false
      },
      method: 'post',
      data: {
        user_id: userId
      }
    })
  }

  return new Promise(function(resolve, reject) {
    resolve()
  })
}

export function getServerSSOInfo() {
  if (isUseAPI()) {
    // 차후 변경될 Restful 형식에 따라 수정해야 함
    return request({
      url: '/hiway/login/sso',
      meta: { apiVersion: '2.0.0' },
      method: 'get'
    })
  }

  // restful api를 사용하지 않을 경우
  // login.json에 등록된 계정만 가져온다.
  return new Promise(function(resolve, reject) {
    // local에서는 token 값에 userId를 넣는다.
    resolve()
  })
}

export function putServerSSOInfo() {
  if (isUseAPI()) {
    // 차후 변경될 Restful 형식에 따라 수정해야 함
    return request({
      url: '/hiway/login/sso',
      meta: { apiVersion: '2.0.0' },
      method: 'put'
    })
  }

  // restful api를 사용하지 않을 경우
  // login.json에 등록된 계정만 가져온다.
  return new Promise(function(resolve, reject) {
    // local에서는 token 값에 userId를 넣는다.
    resolve()
  })
}

export function checkForEmail(email) {
  // local 개발 환경이 아닐 경우, 무조건 서버를 조회해야 함
  if (isUseAPI()) {
    // 차후 변경될 Restful 형식에 따라 수정해야 함
    return request({
      url: '/login/email',
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      // Json에서 Key와 Value 같다면, ecma6 부터는 아래와 같이 쓸 수 있습니다.
      data: {
        email: email
      },
      // post일 경우 data 항목에 json 형식으로 입력하면 payload 값에 입력 되어 들어갑니다.
      // data: {
      //   password: password
      // },
      // 에러 메시지를 출력하는 옵션 - useErrorMessage, false로 정의하면 에러가 나와도 출력되지 않는다. default는 true
      meta: {
        apiVersion: 'v1.0'
      }
    })
  }
}

export function certificateForEmail(number) {
  // local 개발 환경이 아닐 경우, 무조건 서버를 조회해야 함
  if (isUseAPI()) {
    // 차후 변경될 Restful 형식에 따라 수정해야 함
    return request({
      url: '/login/certificate',
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      // Json에서 Key와 Value 같다면, ecma6 부터는 아래와 같이 쓸 수 있습니다.
      data: {
        authCode: number
      },
      // post일 경우 data 항목에 json 형식으로 입력하면 payload 값에 입력 되어 들어갑니다.
      // data: {
      //   password: password
      // },
      // 에러 메시지를 출력하는 옵션 - useErrorMessage, false로 정의하면 에러가 나와도 출력되지 않는다. default는 true
      meta: {
        apiVersion: 'v1.0'
      }
    })
  }
}

export function resetLoginCount() {
  if (isUseAPI()) {
    // 차후 변경될 Restful 형식에 따라 수정해야 함
    return request({
      url: '/login/count',
      method: 'get',
      meta: {
        apiVersion: 'v1.0'
      }
    })
  }
}

export function dateRenew(userId) {
  if (isUseAPI()) {
    // 차후 변경될 Restful 형식에 따라 수정해야 함
    return request({
      url: `/login/renew?user_id=${userId}`,
      headers: { 'Content-Type': 'application/json' },
      meta: { apiVersion: 'v1.0' },
      method: 'get'
    })
  }
}
